<app-page-panel [clipContent]="true">
    <ng-template #header>
        <div class="flex flex-row align-items-center gap-3 flex-wrap">
            <div class="flex align-items-center gap-2">
                <label>Mostra:</label>
                <p-selectButton [options]="invoiceViewOptions"
                                [(ngModel)]="selectedInvoiceView"
                                optionLabel="label"
                                optionValue="value"
                                (onChange)="onInvoiceViewChange(table)">
                </p-selectButton>
            </div>
            <app-input [model]="globalSearch"
                       (modelChange)="updateGlobalSearch(table, $event)"
                       placeholder="Cerca..."
                       icon="fas fa-search"
                       label="Ricerca globale:"
                       labelWidth="auto"
                       inputWidth="220px"
                       [showLength]="false">
            </app-input>
            <app-action-button icon="fas fa-filter-circle-xmark"
                               pTooltip="Pulisci filtri"
                               (click)="clearFilters(table)">
            </app-action-button>
            <app-action-button type="reload"
                               [loading]="loading"
                               pTooltip="Ricarica la tabella (questo tasto NON scarica i dati dal sito di BeActive)"
                               (click)="loadData()">
            </app-action-button>
        </div>

    </ng-template>

    <ng-template #icons>
        <div class="flex flex-row align-items-center gap-3 flex-wrap">
            <app-input label="Margine:" [(model)]="amountDifferenceDelta" labelWidth="auto" type="number"
                       [stepValue]="0.01"
                       inputWidth="100px" [showLength]="false" icon="fas fa-euro"
                       pTooltip="Evidenzia le righe il cui valore di differenza supera o eguaglia questo margine"/>

            <app-counter-badge entitySingular="Fattura"
                               entityPlural="Fatture"
                               [count]="filteredCount"
                               [totalCount]="invoices.length"/>
        </div>
    </ng-template>

    <p-table appTableLastInteractedRow #table
             class="p-datatable p-datatable-striped p-datatable-sm p-datatable-gridlines an-invoices-table"
             [value]="invoices"
             [globalFilterFields]="globalFilterFields"
             [rows]="25"
             [rowsPerPageOptions]="[25, 50, 100, 300]"
             [paginator]="true"
             [rowHover]="true"
             [loading]="loading"
             [scrollable]="true"
             scrollHeight="flex"
             [sortField]="invoiceStringifier.invoiceDate.toString()"
             [sortOrder]="-1"
             (onFilter)="onFilter($event)">
        <ng-template pTemplate="header">
            <tr class="table-header">
                <th>
                    Tipo
                </th>
                <th [pSortableColumn]="invoiceStringifier.invoiceNumber.toString()">
                    Numero
                    <p-sortIcon [field]="invoiceStringifier.invoiceNumber.toString()"></p-sortIcon>
                </th>
                <th [pSortableColumn]="invoiceStringifier.invoiceYear.toString()">
                    Anno
                    <p-sortIcon [field]="invoiceStringifier.invoiceYear.toString()"></p-sortIcon>
                </th>
                <th [pSortableColumn]="invoiceStringifier.invoiceDate.toString()">
                    Data fattura
                    <p-sortIcon [field]="invoiceStringifier.invoiceDate.toString()"></p-sortIcon>
                </th>
                <th [pSortableColumn]="invoiceStringifier.invoiceDescription.toString()">
                    Descrizione
                    <p-sortIcon [field]="invoiceStringifier.invoiceDescription.toString()"></p-sortIcon>
                </th>
                <th [pSortableColumn]="invoiceStringifier.competenceFrom!.toString()">
                    Competenza da
                    <p-sortIcon [field]="invoiceStringifier.competenceFrom!.toString()"></p-sortIcon>
                </th>
                <th [pSortableColumn]="invoiceStringifier.competenceTo!.toString()">
                    Competenza a
                    <p-sortIcon [field]="invoiceStringifier.competenceTo!.toString()"></p-sortIcon>
                </th>
                <th [pSortableColumn]="invoiceStringifier.amountWithoutVat.toString()"
                    pTooltip="Imponibile come riportato sul PDF">
                    Imponibile fattura
                    <p-sortIcon [field]="invoiceStringifier.amountWithoutVat.toString()"></p-sortIcon>
                </th>
                <th [pSortableColumn]="invoiceStringifier.calculatedTotalAmountWithoutVat.toString()"
                    pTooltip="Imponibile calcolato a partire dalle righe del CSV">
                    Imponibile CSV
                    <p-sortIcon [field]="invoiceStringifier.calculatedTotalAmountWithoutVat.toString()"></p-sortIcon>
                </th>
                <th pTooltip="Differenza tra imponibile fattura e imponibile CSV">
                    Differenza
                </th>
                <th [pSortableColumn]="invoiceStringifier.vatPercentage.toString()">
                    IVA
                    <p-sortIcon [field]="invoiceStringifier.vatPercentage.toString()"></p-sortIcon>
                </th>
                <th [pSortableColumn]="invoiceStringifier.rowsWithErrorsCount.toString()" class="errors-cell">
                    Errori o segnalazioni rilevate
                    <p-sortIcon [field]="invoiceStringifier.rowsWithErrorsCount.toString()"></p-sortIcon>
                </th>
                <th class="actions-cell">
                    Azioni
                </th>
            </tr>
            <tr class="table-filters">
                <th></th>
                <th>
                    <app-table-int-filter [field]="invoiceStringifier.invoiceNumber.toString()"
                                          inputWidth="80px"/>
                </th>
                <th>
                    <app-table-int-filter [field]="invoiceStringifier.invoiceYear.toString()"
                                          inputWidth="80px"/>
                </th>
                <th></th>
                <th>
                    <app-table-string-filter [field]="invoiceStringifier.invoiceDescription.toString()"
                                             inputWidth="180px"/>
                </th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
            <tr>
                <td class="type-cell">
                    <img [src]="getInvoiceTypeIconSrc(obj(item))"
                         [alt]="invoiceTypeLabel(obj(item))"
                         class="invoice-type-icon"
                         [pTooltip]="invoiceTypeLabel(obj(item))"
                         tooltipPosition="top">
                </td>
                <td>{{ obj(item).invoiceNumber }}</td>
                <td>{{ obj(item).invoiceYear }}</td>
                <td>{{ obj(item).invoiceDate | appDate:'dd/MM/yyyy' }}</td>
                <td class="description-cell">{{ obj(item).invoiceDescription }}</td>
                <td>{{ obj(item).competenceFrom | appDate:'dd/MM/yyyy' }}</td>
                <td>{{ obj(item).competenceTo | appDate:'dd/MM/yyyy' }}</td>
                <td class="text-right">{{ obj(item).amountWithoutVat | number:'1.2-2' }} €</td>
                <td class="text-right">
                    @if (!obj(item).isCreditNote()) {
                        @if (obj(item).hasParsed) {
                            {{ obj(item).calculatedTotalAmountWithoutVat | number:'1.2-2' }} €
                        } @else {
                            <span class="text-muted">Analisi in corso...</span>
                        }
                    }
                </td>
                <td class="text-right amount-difference"
                    [class.amount-difference-alert]="hasRelevantAmountDifference(obj(item))">
                    @if (!obj(item).isCreditNote() && obj(item).hasParsed) {
                        {{ getAmountDifference(obj(item)) | number:'1.2-2' }} €
                    }
                </td>
                <td class="text-right">{{ obj(item).vatPercentage | number:'1.2-2' }}%</td>
                <td class="text-center errors-cell">
                    <span [class.errors-detected]="obj(item).rowsWithErrorsCount > 0"
                          [attr.aria-label]="obj(item).rowsWithErrorsCount + ' avvertenze rilevate'">
                        {{ obj(item).rowsWithErrorsCount ?? 0 }}
                    </span>
                </td>
                <td class="actions-cell">
                    <a pButton
                       class="p-button-text p-button-sm invoice-details-button"
                       icon="fa fa-arrow-right"
                       target="_blank"
                       [href]="'/' + Routing.anInvoices.byId(obj(item).beActiveRawInvoiceHeaderId)"
                       [attr.aria-label]="'Apri dettaglio fattura ' + obj(item).invoiceNumber"
                       pTooltip="Dettaglio fattura"
                       tooltipPosition="left"></a>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="13">Nessuna fattura trovata</td>
            </tr>
        </ng-template>
    </p-table>
</app-page-panel>
